(() => {
  const normalizeCategory = (value = '') => String(value).trim().toLowerCase();

  const updateArrowState = (carousel, previousButton, nextButton) => {
    const maxScroll = Math.max(0, carousel.scrollWidth - carousel.clientWidth);
    previousButton.disabled = carousel.scrollLeft <= 2;
    nextButton.disabled = carousel.scrollLeft >= maxScroll - 2;
  };

  const initializeSupportCenter = (section) => {
    if (!section || section.dataset.supportReady === 'true') return;

    const tabs = [...section.querySelectorAll('[data-support-tab]')];
    const cards = [...section.querySelectorAll('[data-support-product]')];
    const carousel = section.querySelector('[data-support-carousel]');
    const previousButton = section.querySelector('[data-support-prev]');
    const nextButton = section.querySelector('[data-support-next]');

    const applyCategory = (category) => {
      const normalizedCategory = normalizeCategory(category);
      tabs.forEach((tab) => {
        const active = normalizeCategory(tab.dataset.supportTab) === normalizedCategory;
        tab.classList.toggle('is-active', active);
        tab.setAttribute('aria-selected', String(active));
      });

      cards.forEach((card) => {
        card.hidden = normalizeCategory(card.dataset.supportProduct) !== normalizedCategory;
      });

      if (carousel) carousel.scrollTo({ left: 0, behavior: 'smooth' });
      window.requestAnimationFrame(() => {
        if (carousel && previousButton && nextButton) {
          updateArrowState(carousel, previousButton, nextButton);
        }
      });
    };

    tabs.forEach((tab) => {
      tab.addEventListener('click', () => applyCategory(tab.dataset.supportTab));
    });

    if (tabs.length) applyCategory(tabs.find((tab) => tab.classList.contains('is-active'))?.dataset.supportTab || tabs[0].dataset.supportTab);

    if (carousel && previousButton && nextButton) {
      const scrollCarousel = (direction) => {
        const visibleCard = carousel.querySelector('[data-support-product]:not([hidden])');
        const step = visibleCard ? visibleCard.getBoundingClientRect().width + 18 : carousel.clientWidth * 0.8;
        carousel.scrollBy({ left: direction * step, behavior: 'smooth' });
      };

      previousButton.addEventListener('click', () => scrollCarousel(-1));
      nextButton.addEventListener('click', () => scrollCarousel(1));
      carousel.addEventListener('scroll', () => updateArrowState(carousel, previousButton, nextButton), { passive: true });
      window.addEventListener('resize', () => updateArrowState(carousel, previousButton, nextButton));
      updateArrowState(carousel, previousButton, nextButton);
    }

    section.dataset.supportReady = 'true';
  };

  const initializeAll = (root = document) => {
    root.querySelectorAll('[data-jinmang-support]').forEach(initializeSupportCenter);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeAll());
  } else {
    initializeAll();
  }

  document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
})();
